import { useTheme } from '../../theme/ThemeContext';
function buildGapStyle(gap, divider, spacingMap) {
  if (!gap) return {};
  // With a divider, the 1px track is a full grid column and CSS gap fires on
  // both sides of it. Applying only rowGap avoids doubling the horizontal gutter;
  // the column Stacks' own padding provides the horizontal breathing room.
  if (divider) return {
    rowGap: spacingMap[gap]
  };
  return {
    gap: spacingMap[gap]
  };
}
function buildSideBySideTemplate(childCount) {
  return Array.from({
    length: childCount
  }, (_, i) => i < childCount - 1 ? '1fr 1px' : '1fr').join(' ');
}
function buildGridTemplate({
  divider,
  isStacked,
  minColumnWidth,
  childCount
}) {
  if (!divider) return `repeat(auto-fit, minmax(${minColumnWidth}px, 1fr))`;
  if (isStacked) return '1fr';
  return buildSideBySideTemplate(childCount);
}
export const useAutoColumnsStyles = ({
  minColumnWidth,
  gap,
  divider,
  isStacked,
  childCount
}) => {
  const theme = useTheme();
  const SPACING_MAP = {
    '100': theme.spacing['100'],
    '200': theme.spacing['200'],
    '300': theme.spacing['300'],
    '400': theme.spacing['400']
  };
  return Object.assign({
    display: 'grid',
    gridTemplateColumns: buildGridTemplate({
      divider,
      isStacked,
      minColumnWidth,
      childCount
    })
  }, buildGapStyle(gap, divider, SPACING_MAP));
};